module.exports = __webpack_public_path__ + "static/media/cement.a76de6ae.jpg";